export var PacketConst;
(function (PacketConst) {
    PacketConst[PacketConst["PK_STX"] = 192] = "PK_STX";
    PacketConst[PacketConst["PK_ETX"] = 193] = "PK_ETX";
    PacketConst[PacketConst["PK_DLE"] = 125] = "PK_DLE";
    PacketConst[PacketConst["PK_POS_CMD"] = 1] = "PK_POS_CMD";
    PacketConst[PacketConst["PK_POS_RESULT"] = 2] = "PK_POS_RESULT";
    PacketConst[PacketConst["PK_POS_LENG1"] = 2] = "PK_POS_LENG1";
    PacketConst[PacketConst["PK_POS_LENG2"] = 3] = "PK_POS_LENG2";
    PacketConst[PacketConst["PK_HEADER_SIZE"] = 3] = "PK_HEADER_SIZE";
})(PacketConst || (PacketConst = {}));
export var SettingType;
(function (SettingType) {
    SettingType[SettingType["Timestamp"] = 1] = "Timestamp";
    SettingType[SettingType["AutoPowerOffTime"] = 2] = "AutoPowerOffTime";
    SettingType[SettingType["PenCapOff"] = 3] = "PenCapOff";
    SettingType[SettingType["AutoPowerOn"] = 4] = "AutoPowerOn";
    SettingType[SettingType["Beep"] = 5] = "Beep";
    SettingType[SettingType["Hover"] = 6] = "Hover";
    SettingType[SettingType["OfflineData"] = 7] = "OfflineData";
    SettingType[SettingType["LedColor"] = 8] = "LedColor";
    SettingType[SettingType["Sensitivity"] = 9] = "Sensitivity";
    SettingType[SettingType["UsbMode"] = 10] = "UsbMode";
    SettingType[SettingType["DownSampling"] = 11] = "DownSampling";
    SettingType[SettingType["BtLocalName"] = 12] = "BtLocalName";
    SettingType[SettingType["FscSensitivity"] = 13] = "FscSensitivity";
    SettingType[SettingType["DataTransmissionType"] = 14] = "DataTransmissionType";
    SettingType[SettingType["BeepAndLight"] = 16] = "BeepAndLight";
})(SettingType || (SettingType = {}));
export var Cmd;
(function (Cmd) {
    // 아래의 내용은 어디서 나온 것이지?
    Cmd[Cmd["ONLINE_PEN_DATA_REQUEST"] = 18] = "ONLINE_PEN_DATA_REQUEST";
    Cmd[Cmd["ONLINE_PEN_DATA_RESPONSE"] = 146] = "ONLINE_PEN_DATA_RESPONSE";
    Cmd[Cmd["ONLINE_PEN_DOT_EVENT_V100"] = 101] = "ONLINE_PEN_DOT_EVENT_V100";
    Cmd[Cmd["ONLINE_PEN_DOT_EVENT_V200"] = 102] = "ONLINE_PEN_DOT_EVENT_V200";
    Cmd[Cmd["ONLINE_PEN_DOWN_EVENT_V212"] = 105] = "ONLINE_PEN_DOWN_EVENT_V212";
    Cmd[Cmd["ONLINE_PEN_HOVER_MOVE_EVENT"] = 111] = "ONLINE_PEN_HOVER_MOVE_EVENT";
    Cmd[Cmd["ENCRYPTION_CERT_UPDATE_REQUEST"] = 6] = "ENCRYPTION_CERT_UPDATE_REQUEST";
    Cmd[Cmd["ENCRYPTION_CERT_UPDATE_RESPONSE"] = 134] = "ENCRYPTION_CERT_UPDATE_RESPONSE";
    Cmd[Cmd["ENCRYPTION_CERT_DELETE_REQUEST"] = 7] = "ENCRYPTION_CERT_DELETE_REQUEST";
    Cmd[Cmd["ENCRYPTION_CERT_DELETE_RESPONSE"] = 135] = "ENCRYPTION_CERT_DELETE_RESPONSE";
    Cmd[Cmd["ENCRYPTION_KEY_REQUEST"] = 8] = "ENCRYPTION_KEY_REQUEST";
    Cmd[Cmd["ENCRYPTION_KEY_RESPONSE"] = 136] = "ENCRYPTION_KEY_RESPONSE";
    Cmd[Cmd["ENCRYPTION_ONLINE_PAPER_INFO_EVENT"] = 9] = "ENCRYPTION_ONLINE_PAPER_INFO_EVENT";
    Cmd[Cmd["ENCRYPTION_ONLINE_PEN_DOT_EVENT"] = 10] = "ENCRYPTION_ONLINE_PEN_DOT_EVENT";
    Cmd[Cmd["ENCRYPTION_OFFLINE_PACKET_REQUEST"] = 11] = "ENCRYPTION_OFFLINE_PACKET_REQUEST";
    Cmd[Cmd["ENCRYPTION_OFFLINE_PACKET_RESPONSE"] = 139] = "ENCRYPTION_OFFLINE_PACKET_RESPONSE";
    // PenClientParserV2.cs 에 있는 내용
    Cmd[Cmd["VERSION_REQUEST"] = 1] = "VERSION_REQUEST";
    Cmd[Cmd["VERSION_RESPONSE"] = 129] = "VERSION_RESPONSE";
    Cmd[Cmd["PASSWORD_REQUEST"] = 2] = "PASSWORD_REQUEST";
    Cmd[Cmd["PASSWORD_RESPONSE"] = 130] = "PASSWORD_RESPONSE";
    Cmd[Cmd["PASSWORD_CHANGE_REQUEST"] = 3] = "PASSWORD_CHANGE_REQUEST";
    Cmd[Cmd["PASSWORD_CHANGE_RESPONSE"] = 131] = "PASSWORD_CHANGE_RESPONSE";
    Cmd[Cmd["SETTING_INFO_REQUEST"] = 4] = "SETTING_INFO_REQUEST";
    Cmd[Cmd["SETTING_INFO_RESPONSE"] = 132] = "SETTING_INFO_RESPONSE";
    Cmd[Cmd["LOW_BATTERY_EVENT"] = 97] = "LOW_BATTERY_EVENT";
    Cmd[Cmd["SHUTDOWN_EVENT"] = 98] = "SHUTDOWN_EVENT";
    Cmd[Cmd["SETTING_CHANGE_REQUEST"] = 5] = "SETTING_CHANGE_REQUEST";
    Cmd[Cmd["SETTING_CHANGE_RESPONSE"] = 133] = "SETTING_CHANGE_RESPONSE";
    Cmd[Cmd["ONLINE_DATA_REQUEST"] = 17] = "ONLINE_DATA_REQUEST";
    Cmd[Cmd["ONLINE_DATA_RESPONSE"] = 145] = "ONLINE_DATA_RESPONSE";
    Cmd[Cmd["ONLINE_PEN_UPDOWN_EVENT"] = 99] = "ONLINE_PEN_UPDOWN_EVENT";
    Cmd[Cmd["ONLINE_PAPER_INFO_EVENT"] = 100] = "ONLINE_PAPER_INFO_EVENT";
    Cmd[Cmd["ONLINE_PEN_DOT_EVENT"] = 101] = "ONLINE_PEN_DOT_EVENT";
    Cmd[Cmd["ONLINE_PEN_ERROR_EVENT"] = 104] = "ONLINE_PEN_ERROR_EVENT";
    Cmd[Cmd["ONLINE_NEW_PEN_DOWN_EVENT"] = 105] = "ONLINE_NEW_PEN_DOWN_EVENT";
    Cmd[Cmd["ONLINE_NEW_PEN_UP_EVENT"] = 106] = "ONLINE_NEW_PEN_UP_EVENT";
    Cmd[Cmd["ONLINE_NEW_PAPER_INFO_EVENT"] = 107] = "ONLINE_NEW_PAPER_INFO_EVENT";
    Cmd[Cmd["ONLINE_NEW_PEN_DOT_EVENT"] = 108] = "ONLINE_NEW_PEN_DOT_EVENT";
    Cmd[Cmd["ONLINE_NEW_PEN_ERROR_EVENT"] = 109] = "ONLINE_NEW_PEN_ERROR_EVENT";
    Cmd[Cmd["ONLINE_ENCRYPTION_PAPER_INFO_EVENT"] = 110] = "ONLINE_ENCRYPTION_PAPER_INFO_EVENT";
    Cmd[Cmd["ONLINE_ENCRYPTION_PEN_DOT_EVENT"] = 111] = "ONLINE_ENCRYPTION_PEN_DOT_EVENT";
    Cmd[Cmd["OFFLINE_NOTE_LIST_REQUEST"] = 33] = "OFFLINE_NOTE_LIST_REQUEST";
    Cmd[Cmd["OFFLINE_NOTE_LIST_RESPONSE"] = 161] = "OFFLINE_NOTE_LIST_RESPONSE";
    Cmd[Cmd["OFFLINE_PAGE_LIST_REQUEST"] = 34] = "OFFLINE_PAGE_LIST_REQUEST";
    Cmd[Cmd["OFFLINE_PAGE_LIST_RESPONSE"] = 162] = "OFFLINE_PAGE_LIST_RESPONSE";
    Cmd[Cmd["OFFLINE_DATA_REQUEST"] = 35] = "OFFLINE_DATA_REQUEST";
    Cmd[Cmd["OFFLINE_DATA_RESPONSE"] = 163] = "OFFLINE_DATA_RESPONSE";
    Cmd[Cmd["OFFLINE_PACKET_REQUEST"] = 36] = "OFFLINE_PACKET_REQUEST";
    Cmd[Cmd["OFFLINE_PACKET_RESPONSE"] = 164] = "OFFLINE_PACKET_RESPONSE";
    Cmd[Cmd["OFFLINE_DATA_DELETE_REQUEST"] = 37] = "OFFLINE_DATA_DELETE_REQUEST";
    Cmd[Cmd["OFFLINE_DATA_DELETE_RESPONSE"] = 165] = "OFFLINE_DATA_DELETE_RESPONSE";
    Cmd[Cmd["FIRMWARE_UPLOAD_REQUEST"] = 49] = "FIRMWARE_UPLOAD_REQUEST";
    Cmd[Cmd["FIRMWARE_UPLOAD_RESPONSE"] = 177] = "FIRMWARE_UPLOAD_RESPONSE";
    Cmd[Cmd["FIRMWARE_PACKET_REQUEST"] = 50] = "FIRMWARE_PACKET_REQUEST";
    Cmd[Cmd["FIRMWARE_PACKET_RESPONSE"] = 178] = "FIRMWARE_PACKET_RESPONSE";
    Cmd[Cmd["PEN_PROFILE_REQUEST"] = 65] = "PEN_PROFILE_REQUEST";
    Cmd[Cmd["PEN_PROFILE_RESPONSE"] = 193] = "PEN_PROFILE_RESPONSE";
    Cmd[Cmd["AES_KEY_REQUEST"] = 118] = "AES_KEY_REQUEST";
    Cmd[Cmd["AES_KEY_RESPONSE"] = 246] = "AES_KEY_RESPONSE";
    Cmd[Cmd["PDS_COMMAND_EVENT"] = 115] = "PDS_COMMAND_EVENT";
})(Cmd || (Cmd = {}));
export var PenProfile;
(function (PenProfile) {
    PenProfile[PenProfile["LIMIT_BYTE_LENGTH_PROFILE_NAME"] = 8] = "LIMIT_BYTE_LENGTH_PROFILE_NAME";
    PenProfile[PenProfile["LIMIT_BYTE_LENGTH_PASSWORD"] = 8] = "LIMIT_BYTE_LENGTH_PASSWORD";
    PenProfile[PenProfile["LIMIT_BYTE_LENGTH_KEY"] = 16] = "LIMIT_BYTE_LENGTH_KEY";
    /***
     * request type
     */
    PenProfile[PenProfile["PROFILE_CREATE"] = 1] = "PROFILE_CREATE";
    PenProfile[PenProfile["PROFILE_DELETE"] = 2] = "PROFILE_DELETE";
    PenProfile[PenProfile["PROFILE_INFO"] = 3] = "PROFILE_INFO";
    PenProfile[PenProfile["PROFILE_READ_VALUE"] = 18] = "PROFILE_READ_VALUE";
    PenProfile[PenProfile["PROFILE_WRITE_VALUE"] = 17] = "PROFILE_WRITE_VALUE";
    PenProfile[PenProfile["PROFILE_DELETE_VALUE"] = 19] = "PROFILE_DELETE_VALUE";
    /***
     * status
     */
    PenProfile[PenProfile["PROFILE_STATUS_SUCCESS"] = 0] = "PROFILE_STATUS_SUCCESS";
    PenProfile[PenProfile["PROFILE_STATUS_FAILURE"] = 1] = "PROFILE_STATUS_FAILURE";
    PenProfile[PenProfile["PROFILE_STATUS_EXIST_PROFILE_ALREADY"] = 16] = "PROFILE_STATUS_EXIST_PROFILE_ALREADY";
    PenProfile[PenProfile["PROFILE_STATUS_NO_EXIST_PROFILE"] = 17] = "PROFILE_STATUS_NO_EXIST_PROFILE";
    //    public static readonly byte PROFILE_STATUS_EXIST_KEY_ALREADY = 0x20;
    PenProfile[PenProfile["PROFILE_STATUS_NO_EXIST_KEY"] = 33] = "PROFILE_STATUS_NO_EXIST_KEY";
    PenProfile[PenProfile["PROFILE_STATUS_NO_PERMISSION"] = 48] = "PROFILE_STATUS_NO_PERMISSION";
    PenProfile[PenProfile["PROFILE_STATUS_BUFFER_SIZE_ERR"] = 64] = "PROFILE_STATUS_BUFFER_SIZE_ERR";
})(PenProfile || (PenProfile = {}));
//# sourceMappingURL=pencomm_cmd.js.map